<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.92069 6.66732C6.47269 6.66765 7.00191 6.88748 7.39204 7.278C7.78218 7.66854 8.00101 8.19798 8.00076 8.75C8.00049 9.30207 7.78131 9.83183 7.39074 10.222L4.04504 13.5632C3.80751 13.8006 3.51394 13.9742 3.19152 14.0684L1.28006 14.627C1.10803 14.6771 0.925652 14.6799 0.752067 14.6354C0.578413 14.5909 0.419848 14.5005 0.293083 14.3737C0.166339 14.2469 0.0758505 14.0884 0.0313641 13.9147C-0.0130683 13.7411 -0.0103307 13.5587 0.0398277 13.3867L0.597119 11.474L0.59777 11.4733C0.692148 11.1511 0.866065 10.8578 1.10363 10.6204L4.44803 7.2767C4.8386 6.88652 5.36862 6.66705 5.92069 6.66732ZM5.92004 8.00065C5.74639 8.00057 5.57863 8.06089 5.44543 8.16993L5.39074 8.2194L2.04634 11.5638C1.96759 11.6425 1.90861 11.7396 1.87707 11.8464L1.87772 11.847L1.49035 13.1764L2.81782 12.7891C2.92525 12.7577 3.02317 12.6996 3.10233 12.6204L6.44803 9.27865C6.58842 9.1384 6.66733 8.9478 6.66743 8.74935C6.66751 8.55094 6.58891 8.36043 6.44868 8.22006C6.30849 8.07981 6.11833 8.00081 5.92004 8.00065ZM0.000765157 8.22657V2C0.00076642 1.46957 0.211631 0.961013 0.586703 0.585941C0.961775 0.21087 1.47033 3.38119e-06 2.00077 3.38119e-06H7.3341C7.6328 -0.000513867 7.92853 0.0583203 8.20454 0.172529C8.48073 0.286825 8.73175 0.454396 8.94282 0.666019L11.3341 3.0573L11.4116 3.13802C11.5873 3.33139 11.7281 3.55426 11.8282 3.79623C11.9424 4.07224 12.0013 4.36797 12.0008 4.66667V12.6667C12.0008 13.1971 11.7899 13.7057 11.4148 14.0807C11.0398 14.4558 10.5312 14.6667 10.0008 14.6667H6.44022C6.07203 14.6667 5.77355 14.3682 5.77355 14C5.77355 13.6318 6.07203 13.3333 6.44022 13.3333H10.0008C10.1776 13.3333 10.3471 13.2631 10.4721 13.138C10.5971 13.013 10.6674 12.8435 10.6674 12.6667V5.33334H8.00076C7.64714 5.33334 7.3081 5.19276 7.05806 4.94271C6.80801 4.69266 6.66743 4.35363 6.66743 4V1.33334H2.00077C1.82396 1.33334 1.65443 1.40363 1.52941 1.52865C1.40439 1.65367 1.3341 1.82319 1.3341 2V8.22657C1.3341 8.59476 1.03562 8.89323 0.667432 8.89323C0.299242 8.89323 0.000765157 8.59476 0.000765157 8.22657ZM10.3914 4L8.00076 1.60938V4H10.3914Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  name: 'DocumentIcon',
  props: {
    size: {
      type: [Number, String],
      default: 11
    },
    fill: {
      type: String,
      default: '#62676D'
    }
  }
};
</script>
